import { Component, inject, Signal } from '@angular/core';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import { DocumentsInformationForm } from './forms/documents-information.form';
import { stages } from '../../documents-information.routes';

@Component({
  selector: 'app-documents-information-section',
  standalone: true,
  imports: [
    StagesComponent,
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent,
    ValidationErrorsComponent
  ],
  providers: [DocumentsInformationForm],
  templateUrl: './documents-information-section.component.html'
})
export class DocumentsInformationSectionComponent {

  public stages: string[] = stages;

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public form: DocumentsInformationForm = inject(DocumentsInformationForm);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.value,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
